import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./i18n/config"; // Initialize i18n first
import "./index.css";

// Fade out and remove static preloader before React paints
const staticPrerender = document.getElementById("static-prerender");
if (staticPrerender) {
  staticPrerender.style.opacity = "0";
  setTimeout(() => staticPrerender.remove(), 400);
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
